import React from "react";

import AdminLogin from "pages/Admin/AdminLogin";

const AdminLanding = () => (<AdminLogin redirectUrl="/admin/home" />);

export default AdminLanding;
